module.exports = __webpack_public_path__ + "img/524596861.95433656.jpg";